"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Sizer = function Sizer(_ref) {
  var _ref2;

  var layout = _ref.layout,
      height = _ref.height,
      width = _ref.width,
      aspectRatio = _ref.aspectRatio;
  var thisAspectRatio = (_ref2 = aspectRatio !== null && aspectRatio !== void 0 ? aspectRatio : height && width ? height / width : undefined) !== null && _ref2 !== void 0 ? _ref2 : 1;
  return layout === 'full' ? /*#__PURE__*/_react["default"].createElement("div", {
    "aria-hidden": "true",
    style: {
      paddingTop: "var(--aspect-ratio,".concat(thisAspectRatio * 100, "%)")
    }
  }) : null;
};

var _default = Sizer;
exports["default"] = _default;